// extracted by mini-css-extract-plugin
module.exports = {"container":"tangram-card_container__sKSC3","styles":"tangram-card_styles__pG9Mb","hide":"tangram-card_hide__yvfHJ"};